import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import React, { CSSProperties, FunctionComponent } from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container, Pill } from './TagInput.style';
import { Label } from './TextInput.style';
import ValidationError from './ValidationError';

interface Option {
  icon?: IconDefinition;
  value: string;
  label?: string;
  disabled?: boolean;
  color?: string;
  textColor?: string;
}

interface Props {
  containerStyle?: CSSProperties;
  label?: string;
  options: Option[];
  onOptionChange: (value: string | string[]) => void;
  value?: string | string[];
  error?: string | false;
  testID?: string;
  multiSelect?: boolean;
}

const TagInput: FunctionComponent<Props> = (props) => {
  const isOptionSelected = (value: string) => {
    if (props.multiSelect) {
      return !!props.value?.includes(value);
    }

    return props.value === value;
  };

  const handleClick = (value: string) => {
    if (props.multiSelect) {
      if (props.value && Array.isArray(props.value) && props.value.includes(value)) {
        const newValues = props.value.filter((v) => v !== value);
        props.onOptionChange(newValues);
      } else {
        props.onOptionChange([...(props.value || []), value]);
      }
    } else {
      props.onOptionChange(value);
    }
  };

  return (
    <div style={props.containerStyle}>
      {props.label && <Label>{props.label}</Label>}

      <Container error={props.error}>
        {props.options.map((option) => (
          // empty div fixes issues where Pill widths are ignored due to parent flex-wrap
          <div key={option.value}>
            <Pill
              $active={isOptionSelected(option.value)}
              $color={option.color}
              $disabled={option.disabled}
              $textColor={option.textColor}
              onClick={() => handleClick(option.value)}
              disabled={option.disabled}
              data-testid={`${props.testID}${option.value}`}
              aria-selected={isOptionSelected(option.value)}
              type="button"
            >
              {option.icon && <FontAwesomeIcon icon={option.icon} size={18} />}

              {option.label && <p>{option.label}</p>}
            </Pill>
          </div>
        ))}
      </Container>

      <ValidationError error={props.error} />
    </div>
  );
};

export default TagInput;
